import { contextFactory } from '@frontend/design-system';
import { CalendarViewV3HeaderContextType } from '../types';

export const [CalendarViewV3HeaderContext, useCalendarViewV3HeaderContext] =
  contextFactory<CalendarViewV3HeaderContextType>(
    'useCalendarViewV3HeaderContext should be used inside CalendarViewV3HeaderContext'
  );
